(function($) {
    'use strict';
    var utils = require('./utils');

    $(document).ready(function() {

        // Empty confirm modal
        var emptyConfirmModal = $('#emptyConfirmModal');
        var emptyConfirmModalTrigger = $('[data-toggle="emptyConfirmModal"]');
        var form_id = emptyConfirmModalTrigger.data('form');

        emptyConfirmModalTrigger.click(function(event) {
            // Early return verifications
            var isFirst = false;
            var isFieldsetEmpty = true;

            if (form_id === 'step2') {
                if ($('#step2')[0].checkValidity() == false) return;
                var tenantEmail = $('#tenant_email').val();
                var tenantCellular = $('#tenant_cellular').val();
                isFieldsetEmpty = ($.trim(tenantEmail) === '') || ($.trim(tenantCellular) === '');
            } else if (form_id === 'step3') {
                if ($('#step3')[0].checkValidity() == false) return;

                isFirst = $('#firstRent_yes').prop('checked');
                isFieldsetEmpty = isFormEmpty('step3_address_2');
            } else if (form_id === 'step4') {
                if ($('#tenant_nojob').prop('checked')) return;
                if ($('#step4')[0].checkValidity() == false) return;

                isFirst = $('#firstJob_yes').prop('checked');
                isFieldsetEmpty = isFormEmpty('step4_employer_2');
            }

            // Early return
            if (isFirst || !isFieldsetEmpty) return;

            // Prevent submit and open modal
            event.preventDefault();
            emptyConfirmModal.modal('show');
        });

        emptyConfirmModal.on('show.bs.modal', function () {
            // Retrieve form id

            // When continue is clicked, submit the form
            var modal = $(this);
            modal.find('[data-action="submit"]').click(function () {
                $('#' + form_id).trigger('submit');
            });
        });
    });

    function isFormEmpty(fieldset_id) {
        var fieldset = document.getElementById(fieldset_id);
        var inputs = fieldset.querySelectorAll('input');
        var selects = fieldset.querySelectorAll('select');
        var values = [];

        // Build value array with all input form
        utils.forEach(inputs, function(index, input) {
            if (input.type !== 'checkbox') {
                values.push(input.value);
            }
        });

        // Build value array with all select form
        utils.forEach(selects, function(index, select) {
            values.push(select.options[select.selectedIndex].value);
        });

        // Clear empty string
        values = values.filter(function(e){return e});

        // Return result
        if (values.length > 0) {
            return false;
        } else {
            return true;
        }
    }


})(require('jquery'));
